/**
 * Global helper functions for audio players.
 *
 * On some iOS devices, we could not hear the audio otherwise.
 *
 * So on Safari, we keep the audio path open with an invisible audio element playing silence.
 */

// determine if we are running on Safari
export const isSafari = (): boolean => {
    return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
}

let silentAudioElement: HTMLAudioElement | null = null;

export const ensureSilentAudioKeeper = () => {
    if (silentAudioElement) return;

    console.log("Starting silent audio keeper for iOS");

    // Create a looping silent audio - 1 second of silence as base64 WAV
    // This is a valid WAV file with 1 second of silence at 8kHz mono
    const silentWav = "data:audio/wav;base64,UklGRigBAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQQBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=";

    silentAudioElement = new Audio(silentWav);
    silentAudioElement.loop = true;
    silentAudioElement.volume = 0.001; // Nearly silent but not zero

    silentAudioElement.play().then(() => {
        console.log("Silent audio keeper started successfully");
    }).catch((e) => {
        console.warn("Could not start silent audio keeper:", e);
        silentAudioElement = null;
    });
}